import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Stone {
  name: string;
  description: string;
  image: string;
}
const stones: Stone[] = [{
  name: 'Granite',
  description: 'Highly resistant to staining, scratching, and heat. Large selection of colors.',
  image: 'https://cdn.magicpatterns.com/uploads/eL9WSqtoxYocgvJPa6WgeW/granite.webp'
}, {
  name: 'Marble',
  description: 'Classic and refined look, timeless beauty. Natural patina develops from use and aging.',
  image: 'https://cdn.magicpatterns.com/uploads/eAdro5D5LPCMvAsDgRVkdW/marble-bianco-slab.jpg.webp'
}, {
  name: 'Quartzite',
  description: 'Genuine natural stone. Resembles marble, but harder and less porous.',
  image: 'https://cdn.magicpatterns.com/uploads/fEyP99J4GVY2vxCTS8qd8u/quartzite.webp'
}, {
  name: 'Quartz',
  description: 'Man-made. Non-porous and durable.',
  image: 'https://cdn.magicpatterns.com/uploads/j6BY4yNrM8SDQMfvW7GhVm/quartz-slab-pattern.jpg.webp'
}, {
  name: 'Soapstone',
  description: 'Vintage look, darkens with time (ages). Incredible heat properties.',
  image: 'https://cdn.magicpatterns.com/uploads/etfeSMZrQb8K5C6WQuNdTP/soapstone-slab-countertop.jpg.webp'
}, {
  name: 'Onyx',
  description: 'Vibrant colors and patterns. Translucent types can be backlit.',
  image: 'https://cdn.magicpatterns.com/uploads/3gvyG7nFRnFQtegxGSjxbx/onyx-slab-countertop.jpg.webp'
}, {
  name: 'Travertine',
  description: 'Range of neutral colors. Weathered, natural look.',
  image: 'https://cdn.magicpatterns.com/uploads/m79amenPNPf8F8s2PKYjgf/travertine-slab.jpg.webp'
}, {
  name: 'Limestone',
  description: 'Soft earth tone colors, warm and inviting look. Can contain fossils.',
  image: 'https://cdn.magicpatterns.com/uploads/3MD7smSdUvz1izjt3bg3f1/limestone-slab.jpg.webp'
}];
export function StoneTypesSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  function scrollByAmount(direction: 1 | -1) {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction * (el.clientWidth * 0.8),
      behavior: 'smooth'
    });
  }
  return <section className="w-full bg-white" data-id="element-83" data-mp="3erlmje77u9ls">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-84" data-mp="3eupwytb9y1kw">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end" data-id="element-85" data-mp="39u2a8ju2w6wh">
          <div className="max-w-2xl" data-id="element-86" data-mp="2m4hndput0phx">
            <h2 className="font-display text-3xl text-brand-charcoal sm:text-4xl" data-id="element-87" data-mp="2h4whswl4piw8">
              Your Choice of Stone
            </h2>
            <p className="mt-5 text-base leading-relaxed text-gray-600" data-id="element-88" data-mp="2w36wat4q2zm1">
              Whether you're looking for the timeless beauty of marble, the strength of granite,
              or the uniformity of quartz, Granite &amp; Marble Works has it.
            </p>
            <p className="mt-4 text-base leading-relaxed text-gray-600" data-id="element-89" data-mp="6ctsdzzcp71r">
              We offer a wide selection of natural and engineered stone in over 250 colors to
              craft one-of-a-kind kitchen countertops, bathroom vanities, fireplace hearths, bar
              tops, and more.
            </p>
          </div>

          <div className="flex shrink-0 gap-2" data-id="element-90" data-mp="4wg49ii90k31">
            <button type="button" onClick={() => scrollByAmount(-1)} aria-label="Scroll stone types left" className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-brand-charcoal transition-colors hover:border-brand-teal hover:text-brand-teal" data-id="element-91" data-mp="4xr7nh7s7ptm">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-92" data-mp="nvbruazlq07w" />
            </button>
            <button type="button" onClick={() => scrollByAmount(1)} aria-label="Scroll stone types right" className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-brand-charcoal transition-colors hover:border-brand-teal hover:text-brand-teal" data-id="element-93" data-mp="rvc9e4hzyrj6">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-94" data-mp="3sreld4pm1cb6" />
            </button>
          </div>
        </div>

        <div ref={scrollRef} className="no-scrollbar mt-10 flex gap-5 overflow-x-auto scroll-smooth pb-2" data-id="element-95" data-mp="3ivbghr3dizkj">
          {stones.map(stone => <div key={stone.name} className="w-56 shrink-0 snap-start overflow-hidden rounded-xl border border-gray-200 sm:w-64" data-id="element-96" data-mp="3evszh6eob8mz">
              <img src={stone.image} alt={`${stone.name} countertop material sample`} className="h-40 w-full object-cover" data-id="element-97" data-mp="agt4jeabazvn" />
              <div className="p-4" data-id="element-98" data-mp="1m52dx019yb2">
                <h3 className="font-display text-lg text-brand-charcoal" data-id="element-99" data-mp="1l3pro3dd3r8">{stone.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-gray-600" data-id="element-100" data-mp="y6dqm61rid95">{stone.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}